import setCookie from './functions/_cookie-setCookie-server.js' // Cookie発行（サーバーサイド）
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import scrollLock from './functions/_scrollLock.js' // スクロールロック

/* global rootDomain */
/* global hUrl */
const cookiePath = hUrl + 'cookie/' // cookie制御パス

// console.log({ rootDomain })

const rateAgree = getCookie('rateAgree') // 成人認証フラグを取得

//  #####      ###    ######  #####
//  ##  ##    ## ##     ##    ##
//  #####    ##   ##    ##    #####
//  ##  ##   #######    ##    ##
//  ##   ##  ##   ##    ##    #####
// レーティングの確認を省略する

// if (location.hash === '#--r-reset') {
//   // ハッシュを検出したら実行
//   // R18エントリーを破棄
//   if (rateAgree === '1') {
//     setCookie('isR', '0', cookiePath, 0) // Cookie発行
//     setCookie('rateAgree', '0', cookiePath, 0) // Cookie発行
//     // クッキーが切り替わるのを確認したらリロード
//     const reloadTimer = setInterval(() => {
//       if (getCookie('isR') === '1' || getCookie('rateAgree') === '1') {
//         return
//       }
//       clearInterval(reloadTimer)
//       window.location.href = hUrl
//     }, 100)
//   }
// }

//  #####    #####   #####
//  ##  ##  ##   ##  ##  ##
//  #####   ##   ##  #####
//  ##      ##   ##  ##
//  ##       #####   ##
if (!rateAgree) {
  // モーダルを呼び出す

  document.querySelector('.js-modal--rating').classList.add('active')

  document.getElementById('modalOverlay').classList.add('active')

  scrollLock('body', '#modalOverlay')
}

// 承諾したらCookieを記録
window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id !== 'rateAgree') {
    return
  }
  // Cookieを設定

  setCookie('isR', '1', cookiePath, 60 * 60 * 24 * 365) // Cookie発行
  setCookie('rateAgree', '1', cookiePath, 60 * 60 * 24 * 365) // Cookie発行

  // クッキーが切り替わるのを確認したらリロード
  // const reloadTimer = setInterval(() => {
  //   if (getCookie('isR') !== '1' || getCookie('rateAgree') !== '1') {
  //     return
  //   }
  //   clearInterval(reloadTimer)
  //   // ジャンプ先があればジャンプ
  //   const jump = getCookie('jump')
  //   if (getCookie('jump')) {
  //     setCookie('jump', '', cookiePath, 0) // Cookie発行
  //     location.href = jump
  //   } else {
  //     // ジャンプ先がなければリロード
  //     window.location.reload()
  //   }
  // }, 100)

  window.modalClose()
})

// Cookieがあったらモーダルをカット
// if (rateAgree === '1') {
//   // モーダルを消す
//   const rateModal = document.getElementsByClassName('js-modal--rating')
//   for (const iterator of rateModal) {
//     iterator.classList.add('js-modal--rating-del')
//   }

//   const rateModalDel = document.getElementsByClassName('js-modal--rating-del')
//   for (const iterator of rateModalDel) {
//     iterator.classList.remove('js-modal--rating') // モーダルを消す
//   }

//   window.addEventListener('click', function (e) {
//     // 指定のクラスを持つ
//     if (e.target.dataset.modal !== 'rating') {
//       return
//     }
//     // モーダルオーバーレイを消す
//     document.getElementById('modalOverlay').style.display = 'none'

//     // Cookieを設定
//     setCookie('isR', '1', cookiePath, 60 * 60 * 24 * 365) // Cookie発行

//     // クッキーが切り替わるのを確認
//     const reloadTimer = setInterval(() => {
//       if (getCookie('isR') !== '1') {
//         return
//       }
//       clearInterval(reloadTimer)

//       // ジャンプ先があればジャンプ
//       const jump = getCookie('jump')
//       if (getCookie('jump')) {
//         setCookie('jump', '', cookiePath, 0, true) // Cookie発行
//         location.href = jump
//       } else {
//         // ジャンプ先がなければリロード
//         window.location.reload()
//       }
//     }, 100)
//   })
// }

// 表に戻る
// window.addEventListener('click', function (e) {
//   // 指定のクラスを持つ
//   if (!e.target.classList.contains('js-allMode')) {
//     return
//   }
//   setCookie('isR', '0', cookiePath, 0) // Cookie発行

//   // クッキーが切り替わるのを確認
//   const reloadTimer = setInterval(() => {
//     if (getCookie('isR') === '1') {
//       return
//     }
//     clearInterval(reloadTimer)
//     window.location.reload()
//   }, 100)
// })
